import { useQContent } from '@exam-management/common/qcontent-provider';
import { SearchQuestionsDocument, usePendingQuestionMutation } from '@exam-management/graphql';
import type { ConfirmationModalProps } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

import { PendingQuestionModal } from '../../components';

type PendingSingleQuestionModalProps = Pick<ConfirmationModalProps, 'open' | 'onClose'>;

export default function PendingSingleQuestionModal(
  props: Readonly<PendingSingleQuestionModalProps>,
) {
  const { open: isOpen, onClose } = props;

  const { qContent } = useQContent();
  const { showSnackbar } = useSnackbar();

  const [pendingQuestion, { loading: isPending }] = usePendingQuestionMutation({
    onCompleted: () => {
      showSnackbar({
        message: 'Question has been pending',
        variant: 'success',
      });
    },
    onError: () => {
      showSnackbar({
        message: 'Unable to Pending Question',
        variant: 'error',
      });
    },
    refetchQueries: [SearchQuestionsDocument],
  });

  const handleAccept: React.MouseEventHandler<HTMLButtonElement> = async (event) => {
    await pendingQuestion({
      variables: {
        id: qContent.id,
      },
    });

    onClose?.(event);
  };

  return (
    <PendingQuestionModal
      loading={isPending}
      open={isOpen}
      onAccept={handleAccept}
      onClose={onClose}
    />
  );
}
